import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NgClass } from "@angular/common";

@Component({
    selector: "app-switcher",
    templateUrl: "./switcher.component.html",
    styleUrls: ["./switcher.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgClass
    ]
})
export class SwitcherComponent implements AfterViewInit {
  @Input() public switcherConfig: any;
  @Input() public selectedIndex = 0;
  @Input() public isDynamicWidth: boolean = false;
  @Output() private selectedSwitch: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('switcherBox') private switcherBox: ElementRef;
  @ViewChild('switcherState') private switcherState: ElementRef;

  public ngAfterViewInit(): void {
    this.updateSwitcherBySelectedIndex();
  }

  @Input() set changeSelectedIndexFromParent(index: string) {
    if (index) {
      this.selectedIndex = +index;
      this.updateSwitcherBySelectedIndex();
    }
  }

  public selectSwitch(
    btnRef: HTMLButtonElement,
    switcher: any,
    index: number,
  ): void {
    this.changeSwitcherStateStyles(btnRef.offsetWidth, btnRef.offsetLeft);
    this.selectedIndex = index;
    this.selectedSwitch.emit(switcher);
  }

  private changeSwitcherStateStyles(width: number, leftOffset: number): void {
    const switcherState = this.switcherState.nativeElement;
    switcherState.setAttribute(
      'style',
      `width: ${width}px; left: ${leftOffset}px`,
    );
  }

  private updateSwitcherBySelectedIndex(): void {
    const btnRef =
      this.switcherBox.nativeElement.getElementsByTagName('button')[
        this.selectedIndex
      ];
    this.changeSwitcherStateStyles(btnRef.offsetWidth, btnRef.offsetLeft);
  }
}
